<div *ngIf="!user?.id" class="py-3 ">
    <div class="d-flex justify-content-center align-items-center">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>

</div>
<div *ngIf="user?.id" class="modal-body p-4 p-lg-60px">

    <h4 class=" border-bottom mb-4 pb-4">
        تغيير كلمة المرور للمستخدم: 
        <span class="fw-normal text-info">
            {{user?.fullName || user?.userName}}
        </span>
    </h4>

    <nz-form class="row custom_form g-3 row-cols-1 row-cols-md-2" [formGroup]="registrationForm"
        (ngSubmit)="onSubmit()">


        <nz-form-item class="mb-0" *ngIf="registrationForm?.get('password') ">
            <nz-form-control [nzErrorTip]="'كلمة المرور مطلوبة'">
                <nz-form-label for="password">كلمة المرور</nz-form-label>
                <input (ngModelChange)="updateConfirmValidator()" nz-input nzSize="large" type="password"
                    formControlName="password" placeholder="كلمة المرور" />
            </nz-form-control>
        </nz-form-item>

        <nz-form-item class="mb-0" *ngIf="registrationForm?.get('confirmPassword')">
            <nz-form-control [nzErrorTip]="errorTpl">
                <nz-form-label for="confirmPassword">تأكيد كلمة المرور</nz-form-label>
                <input nz-input nzSize="large" type="password" formControlName="confirmPassword"
                    placeholder="تأكيد كلمة المرور" />
                <ng-template #errorTpl let-control>
                    <ng-container *ngIf="control.hasError('required')">
                        يجب تأكيد كلمة المرور
                    </ng-container>
                    <ng-container *ngIf="control.hasError('confirm')">
                        كلمة المرور غير متطابقة
                    </ng-container>
                </ng-template>
            </nz-form-control>
        </nz-form-item>
    </nz-form>
</div>
<div *ngIf="user?.id" class="modal-footer justify-content-center text-center border-0">
    <div style="max-width: 550px;" class="mx-auto w-100">
        <button nz-button [nzLoading]="loading" nzType="primary" nzSize="large" class="w-100 mb-3" (click)="onSubmit()">


            <span>
                تغيير كلمة المرور
            </span>
        </button>
    </div>
</div>